export default __webpack_public_path__ + "static/media/ad_970x90_install_en.430f2241.png";